import React from "react";
import { Carousel } from "antd";

import "@/styles/components/university.scss";

const University = () => {
  const data = [
    "/assets/university/Colorado_state_university.png",
    "/assets/university/cornell_univesity.webp",
    "/assets/university/columbia_university.webp",
    "/assets/university/Dartmouth_College.png",
    "/assets/university/Duke_University_logo.jpg",
    "/assets/university/durham_university.webp",
    "/assets/university/georgia_tech.webp",
    "/assets/university/illinois_state_university.png",
    "/assets/university/Johns_Hopkins_university.jpg",
    "/assets/university/kings_college_london.webp",
    "/assets/university/kyoto_university.webp",
    "/assets/university/lancaster_university.webp",
    "/assets/university/london_school_of_economics.webp",
    "/assets/university/Massachutts_univesity_of_technology.png",
    "/assets/university/McGill_university.webp",
    "/assets/university/National_University_California.png",
    "/assets/university/new_jersey_iot.png",
    "/assets/university/Northeastern_University.png",
    "/assets/university/Northwestern_University_seal.png",
    "/assets/university/PSU-mark-navy.jpg",
    "/assets/university/purdue-university.png",
    "/assets/university/queen_marry_university.webp",
    "/assets/university/San_Jose_State_University.png",
    "/assets/university/stanford-university.png",
    "/assets/university/Technische_universitat_monchen.webp",
    "/assets/university/Tufts_University.png",
    "/assets/university/ucl.webp",
    "/assets/university/UNC_Charlotte_Primary_Horiz.webp",
    "/assets/university/University_brihimingham.webp",
    "/assets/university/university_of_arizona.png",
    "/assets/university/university_of_bristol.webp",
    "/assets/university/University_of_california.png",
    "/assets/university/university_of_colombia.webp",
    "/assets/university/University_of_Colorado_Boulder.png",
    "/assets/university/University_of_dayton.jpg",
    "/assets/university/university_of_edinbuirgh.webp",
    "/assets/university/university_of_exeter.webp",
    "/assets/university/university_of_manchaster.webp",
    "/assets/university/university_of_michigan.png",
    "/assets/university/university_of_nottingham.webp",
    "/assets/university/University_of_oxford.webp",
    "/assets/university/University_of_Southern_California_seal.jpeg",
    "/assets/university/University_of_sydney.webp",
    "/assets/university/University_of_Texas_at_Dallas.png",
    "/assets/university/university_of_toronto.webp",
    "/assets/university/university-of-houston.png",
    "/assets/university/University-of-South-Florida.png",
    "/assets/university/UTA.jpg",
    "/assets/university/warwick_university.webp",
    "/assets/university/University_of_Texas_at_Austin.png",
    "/assets/university/imperail_college.png",
    "/assets/university/london_business_school.jpg",
    "/assets/university/nyu_university.png",
    "/assets/university/purdue_university.png",
    "/assets/university/stanford-university.png",
    "/assets/university/trinity_college_london.jpg",
    "/assets/university/university_of_british.webp",
  ];
  const settings = {
    infinite: true,
    autoplay: true,
    autoplaySpeed: 6000,
    speed: 500,
    slidesToShow: 8,
    slidesToScroll: 8,
    arrows: false,
    dots: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: { slidesToShow: 6, slidesToScroll: 6 },
      },
      {
        breakpoint: 992,
        settings: { slidesToShow: 5, slidesToScroll: 5 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 4, slidesToScroll: 4 },
      },
      {
        breakpoint: 445,
        settings: { slidesToShow: 2, slidesToScroll: 2 },
      },
    ],
  };

  return (
    <div className="university title-h5-1">
      <div className="heading">Our Guided Students are at:</div>
      <div className="carousel">
        <div className="custom-carousel">
          <Carousel
            //  {...settings}

            dots={false}
            autoplay={true}
            autoplaySpeed={6000}
            speed={500}
            slidesToShow={8}
            slidesToScroll={8}
            arrows={false}
            responsive={[
              {
                breakpoint: 1200,
                settings: { slidesToShow: 6, slidesToScroll: 6 },
              },
              {
                breakpoint: 992,
                settings: { slidesToShow: 5, slidesToScroll: 5 },
              },
              {
                breakpoint: 768,
                settings: { slidesToShow: 4, slidesToScroll: 4 },
              },
              {
                breakpoint: 445,
                settings: { slidesToShow: 2, slidesToScroll: 2 },
              },
            ]}
          >
            {data.map((src, idx) => (
              <div key={idx} className="carousel-item">
                <img src={src} alt={`University logo ${idx + 1}`} />
              </div>
            ))}
          </Carousel>
        </div>
      </div>
    </div>
  );
};

export default University;
